/* eslint-disable no-useless-escape */

import 'twin.macro';

import React from 'react';
import { Link, useStaticQuery, graphql } from 'gatsby';

import { Heading, Subtitle, Container } from '../atoms';
import SocialIcons from './SocialIcons';
import ContactInfo from '../contact/ContactInfo';
import SanityImage from './SanityImage';

const footerQuery = graphql`
  query footerQuery {
    sanityFooter {
      _id
      description
      footerColumn {
        _key
        heading
        footerOption {
          _key
          name
          linkTo {
            current
          }
        }
      }
    }
    sanityGlobals {
      name
      logoImage {
        asset {
          gatsbyImageData(width: 113, height: 52)
        }
      }
    }
  }
`;

const Footer = () => {
  const { sanityFooter: footerData, sanityGlobals } =
    useStaticQuery(footerQuery);
  if (!footerData) {
    return null;
  }

  function isValidURL(string) {
    const res = string.match(
      /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
    );
    return res !== null;
  }

  return (
    <footer tw="bg-green">
      <Container tw="p-10 ">
        <div tw="inline md:grid grid-cols-4 gap-x-14">
          <div>
            <Link to="/">
              <SanityImage
                tw="my-4"
                fluid={sanityGlobals.logoImage.asset.gatsbyImageData}
                alt={sanityGlobals.name || ''}
              />
            </Link>
            <div tw="my-4">
              <Subtitle color="light">{footerData.description}</Subtitle>
            </div>
            <SocialIcons flex />
          </div>
          {footerData &&
            footerData.footerColumn.map((element) => {
              if (!element) return null;
              return (
                <div key={element._key}>
                  <Heading variant="large" tw="text-gray-light">
                    {element.heading}
                  </Heading>
                  {element.footerOption && element.footerOption.length > 1 ? (
                    <ul tw="list-none mb-10">
                      {element.footerOption.map((item) => (
                        <div tw="mb-5" key={item._key}>
                          {!isValidURL(item.linkTo.current) ? (
                            <Link
                              to={`/${item.linkTo && item.linkTo.current}/`}
                              tw="cursor-pointer text-sm font-normal text-gray-light hover:text-gray-100"
                            >
                              {item.name}
                            </Link>
                          ) : (
                            <a
                              href={`/${item.linkTo && item.linkTo.current}`}
                              tw="cursor-pointer text-sm font-normal text-gray-light hover:text-gray-100"
                            >
                              {item.name}
                            </a>
                          )}
                        </div>
                      ))}
                    </ul>
                  ) : (
                    <ContactInfo />
                  )}
                </div>
              );
            })}
        </div>
        <div tw="flex-initial md:flex justify-between text-gray-light mt-10 items-center">
          <p tw="my-2">
            © {new Date().getFullYear()} Softub Midlands Ltd. All rights
            reserved
          </p>
          <div>
            <Link to="/terms-and-conditions" tw="my-2">
              Terms & Conditions
            </Link>{' '}
            |<Link to="/legal"> Privacy Policy</Link>
          </div>

          <div tw="my-2">
            <img
              height={35}
              width={176}
              src="/images/payment.png"
              alt="A payment"
            />
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
